
import { Component, Vue } from "vue-property-decorator";
import UsersTable from "@/components/user/UsersTable.vue";

@Component({
  name: "users-page",
  components: { UsersTable },
})
export default class UsersPage extends Vue {
  constructor() {
    super();
  }
}
